<ng-container *ngIf="permConfig.isAddAllowed">
  <div class="container-fluid">
    <app-page-title title="Roles"></app-page-title>
  
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form [formGroup]="roleForm">
              <div class="row">
                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="usergroups" class="form-label">User Group<span class="mandatory">*</span></label>
                    <ng-select id="usergroups" formControlName="ddlGroups" [items]="userGroupList" [appendTo]="'body'" [openOnEnter]="false"
                      bindLabel="name" [bindValue]="'id'" placeholder="Select"
                      class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                      [ngClass]="{
                        'is-invalid':
                          (isFormSubmitted ||
                            roleForm.get('ddlGroups').dirty) &&
                          roleForm.get('ddlGroups').errors
                      }" appEnterDirective [onEnterKey]="useEnterKey">
                    </ng-select>
                    <div *ngIf="
                        (isFormSubmitted || roleForm.get('ddlGroups').dirty) &&
                        roleForm.get('ddlGroups').errors
                      " class="invalid-feedback">
                      <span *ngIf="roleForm.get('ddlGroups').errors.required">User Group is required</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="rolename" class="form-label">Role Name <span class="mandatory">*</span></label>
                  <div class="input-group mb-2">
                    <input type="text" class="form-control form-control-sm" id="rolename" maxlength="40"
                      formControlName="txtRoleName" [ngClass]="{
                        'is-invalid':
                          (isFormSubmitted ||
                            roleForm.get('txtRoleName').touched) &&
                          roleForm.get('txtRoleName').errors
                      }"  appEnterDirective [onEnterKey]="useEnterKey"/>
                    <button type="button" class="btn btn-primary btn-sm ml-8 d-flex" (click)="addRole()" (keydown.enter)="addRole()">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                      Add
                    </button>
                    <div *ngIf="
                        (isFormSubmitted ||
                          roleForm.get('txtRoleName').touched) &&
                        roleForm.get('txtRoleName').errors
                      " class="invalid-feedback">
                      <span *ngIf="roleForm.get('txtRoleName').errors.required">Role Name is required</span>
                      <span *ngIf="roleForm.get('txtRoleName').errors.maxlength">
                        Maximum length exceeded (40 characters).</span>
                      <span *ngIf="roleForm.get('txtRoleName').errors.pattern">Invalid input. Use only letters, numbers,
                        hyphen and
                        space.</span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  
    <div class="row">
      <ng-container *ngIf="roleList.length == 0">
        <div class="col-xl-12 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1 overflow-hidden">
                  <p class="text-muted mb-2 text-center mt-2">
                    No Roles are added yet.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngFor="let role of roleList">
        <div class="col-xl-3 col-sm-3">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1 overflow-hidden">
                  <h5 class="text-truncate font-size-16">
                    <a href="javascript: void(0);" class="text-dark">
                      {{ role.rolename }}
                    </a>
                  </h5>
                  <!-- <p class="text-muted mb-4">Admin</p> -->
                  <a href="javascript: void(0);" class="badge bg-success font-size-9 me-2">{{ role.groupname }}</a>
                  <a href="javascript: void(0);"><i class="bx bx-group me-0"></i> {{ role.usercount }}
                  </a>
                </div>
              </div>
            </div>
            <div class="card-footer bg-transparent border-top">
              <div class="contact-links font-size-18">
                <div class="float-end">
                  <i class="bx bx-trash me-1 text-danger" title="Delete Role" (click)="onDeleteRole(role.id)"></i>
                </div>
                <div class="float-end">
                  <a><i class="bx bx-edit me-1 text-warning" title="Edit Role" (click)="open(role.id)"></i></a>
                  <!-- <button class="btn btn-primary btn-sm font-size-11 m-0">
                    <i class="bx bx-edit me-1" title="Edit Role Permissions"></i> Permissions
                  </button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  
  
  </div>
  
</ng-container>
<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>